export default __webpack_public_path__ + "static/media/remove-cross.6953fc04.svg";